




















































import Navigation from '@/components/Navigation'
import MobileNavigation from '@/components/MobileNavigation'

export default {
    name: 'PageHeader'

    components:
        Navigation: Navigation
        MobileNavigation: MobileNavigation

    props: ['id']

    watch:
        id: (val) ->
            @fields = @defaultFields() 
            @$forceUpdate()
            @setContent val

    data: ->
        documentId: ''
        fields: @defaultFields()

    computed:
        background: -> @$parent.fields.header_background
        isTransparent: -> @background is 'transparent'
        isDark: ->
            !@$parent.isDark && @isTransparent
        navbarClass: ->
            'cm-header-light uk-light': @isDark
            'uk-navbar-transparent uk-position-top': @isTransparent

        logo: ->
            if @isDark then @fields.logo_light else @fields.logo_dark

    methods:
        defaultFields: ->
            logo_dark: []
            logo_light: []
            logo: []

        setContent: (document) ->
            @documentId = document.id
            fields = 
                logo_dark: document.data.logo_dark
                logo_light: document.data.logo_light
                navigation: document.data.navigation
            $.extend @fields, fields

        getContent: (id) ->
            @$prismic.client.query(@$prismic.Predicates.at 'document.id', id).then (response) =>
                if response.results then @setContent response.results[0]
            
    created: ->
        @getContent @id
}
